import Toastr from "../../../components/Toastr"

const DEFAULT_STATE = {
  saving: false,
  editing: false,
  findings: [],
  finding: {},
  meta: { pagination: {} },
}

let changes = null;
export default function findingSettingReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let findings = [];
  let updatedRecord = {};

  switch (action.type) {

    case 'FINDING_SETTINGS_LOAD_PENDING':
    case 'FINDING_SETTING_CREATE_PENDING':
    case 'FINDING_SETTING_UPDATE_PENDING':
      return { ...state, saving: true };

    case 'FINDING_SETTINGS_LOAD_REJECTED':
    case 'FINDING_SETTING_CREATE_REJECTED':
    case 'FINDING_SETTING_DELETE_REJECTED':
    case 'FINDING_SETTING_UPDATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case 'FINDING_SETTINGS_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false
      }
      return { ...state, ...changes };

    case 'FINDING_SETTING_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      state.findings.unshift(response.finding)
      changes = {
        finding: {},
        saving: false
      }
      return { ...state, ...changes };

    case 'FINDING_SETTING_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      findings = [...state.findings];
      updatedRecord = response.finding;
      for (const [index, finding] of findings.entries()) {
        if (finding.id === updatedRecord.id) {
          findings = [
            ...findings.slice(0, index),
            updatedRecord,
            ...findings.slice(index + 1)
          ];
        }
      }
      changes = { findings: findings, finding: {}, saving: false }
      return { ...state, ...changes };

    case 'FINDING_SETTING_DELETE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      findings = [...state.findings];
      for (const [index, finding] of findings.entries()) {
        if (finding.id === response.finding.id) {
          findings.splice(index, 1);
        }
      }
      return { ...state, findings: findings, saving: false };

    case 'FINDING_SETTING_CHANGE':
      changes = {
        finding: action.data
      };
      return { ...state, ...changes };

    case 'FINDING_SETTING_CHANGE_CANCEL':
      changes = {
        finding: {}
      };
      return { ...state, ...changes };

    case 'FINDING_SETTING_EDIT':
      changes = {
        editing: { ...state.editing, ...action.data }
      };
      return { ...state, ...changes };

    case 'FINDING_SETTING_EDIT_CANCEL':
      changes = {
        editing: false
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}